import React, { useState, useEffect, useRef } from "react";
import { Grid, Button, Box } from "@material-ui/core";

import "./style.css";
import POAlertDialog from "./PoTableAlert";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import getParameterByName from "../../../../Functions/functions";
import axios from "axios";

import "handsontable/dist/handsontable.full.min.css";
import { HotTable } from "@handsontable/react";
import Handsontable from "handsontable";
import { registerAllModules } from "handsontable/registry";
import CustomSnackbar from "../../../../CustomSnackbar";
import { getDistributorData } from "../../actions";

registerAllModules();

const GL_TableV2 = ({ data, formState, setFormState, show, reviwerFlag, setInvoice_Amount_formatted , role , setErrorMessage }) => {
  const tableData = {
    rowId: "",
    accountId: 0,
    invoice_Id: Number(formState.invoice_Id), // number for departCord
    glAccount: undefined,
    accountType: "Debit",
    costCenter: "",
    costCenterOwner: "",
    costCenterOwnerName: "",
    wbsElement: "",
    horizonId: "",
    vendor_Code: "",
    amount: 0,
    profitCenter: "",
    department: "",
    description: `${formState.invoice_Desc}`,
    // fsDocDate: formState?.invoice_Type === 'Final Settlement - Distributor' ? (formState?.fsDocDate || '') : '',
    // fsDocNo: formState?.invoice_Type === 'Final Settlement - Distributor' ? (formState?.fsDocNo || '') : '',
    // vendorCode: formState?.invoice_Type === 'Final Settlement - Distributor' ? (formState?.vendor_Code?.Vendor_Code ? `${formState.vendor_Code.Vendor_Code} - ${formState.vendor_Code.Vendor_Name}` : '') : '',
    // customerAccountNo: formState?.invoice_Type === 'Final Settlement - Distributor' ? (formState?.distributor_Code || '') : '',
  };
  const [alertMessage, setAlertMessage] = useState("");
  const [erralertMessage, setErrAlertMessage] = useState("");
  const [vendorblock, setvendorblock] = useState(false);
  const invoiceId = getParameterByName("invoiceId");
  const [tableHeight, setTableHeight] = useState(80);
const ROW_HEIGHT = 80;
const MAX_HEIGHT = 200;
const ROW_INCREMENT = 40;

  const invoicePayload = {
    Invoice_id: invoiceId,
  };

  const addInput = () => {
    const num = Math.random();
    tableData.rowId = num;
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: [...formState.invoice_Accounts_list, tableData],
    }));
  };

  const hotRef = useRef(null);
  const [columns, setColumns] = useState([]);

  const columnHeaders = [
    "", // auto-number column header
    "GL Account",
    "Amount",
    "CostCenter",
    "CC Owner Code",
    "CC Owner",
    "Profit Center",
    "WBS element",
    "Text",
  ];

  const fsCols = ["", "FS Doc", "FS Doc Date"];
  const distributorCols = [
    "", // auto-number header
    " ",
    "Customer Account No",
    "FSDS Doc",
    "FSDS Date",
    "Amount",
    "Vendor Code",
  ];
  const hrColumnHeaders = [
    "", // auto-number header
    "GL Account",
    "Amount",
    "Horizon Id",
    "Vendor Code",
    "Department",
    "CostCenter",
    "CC Owner Code",
    "CC Owner",
    "Profit Center",
  ];

  const adjustAmountOnGLTable = (tempArr) => {
    let newAmount = Number(formState?.invoice_Amount);
    if (tempArr.length > 0) {
      for (let i = 0; i < tempArr.length; i++) {
        const item = tempArr[i];
        // if (index === 0 && item.amount == 0) {
        newAmount = newAmount - Number(item.amount);
        // }
      }
    }
    return newAmount;
  };

  const handleAfterChange = async (changes, source) => {
    if (changes == null || changes == undefined) return;
    var self = this;
    const str = JSON.stringify(formState?.invoice_Accounts_list);
    const tempArr = JSON.parse(str);
    for (let i = 0; i < changes.length; i++) {
      tempArr[changes[i][0]]["accountId"] = 0;
      tempArr[changes[i][0]]["accountType"] = "Debit";
      tempArr[changes[i][0]]["invoice_Id"] = Number(formState.invoice_Id);

      tempArr[changes[i][0]]["created_By"] = "";
      tempArr[changes[i][0]]["created_On"] = new Date();
      tempArr[changes[i][0]]["updated_By"] = "";
      tempArr[changes[i][0]]["updated_On"] = new Date();
      if (!tempArr[changes[i][0]]?.rowId) {
        const num = Math.random();
        tempArr[changes[i][0]].rowId = num;
      }

      if (changes[i][1] == "costCenter") {
        var _cc = changes[i][3];
        // var data = { 'costCenterCode': _cc.split('-')[0].trim() };
        if (
          tempArr[changes[i][0]]["profitCenter"] ||
          tempArr[changes[i][0]]["wbsElement"]
        ) {
          setAlertMessage(
            "Profit center is already entered, so can't select cost center"
          );
          tempArr[changes[i][0]]["costCenterOwner"] = "";
          tempArr[changes[i][0]]["costCenterOwnerName"] = "";
          tempArr[changes[i][0]]["costCenter"] = "";
        } else {
          if (_cc) {
            await axios({
              method: "get", //you can set what request you want to be
              url: `${
                process.env.REACT_APP_API_URL
              }/api/Invoices/GetEmployeeByCostCenter_v1/${_cc
                .split("-")[0]
                .trim()}`,
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                "Content-Type": "application/json",
              },
            })
              .then((response) => {
                if (response.data != undefined) {
                  tempArr[changes[i][0]]["costCenterOwner"] =
                    response.data.employeeCode;
                  tempArr[changes[i][0]]["costCenterOwnerName"] =
                    response.data.employeeName;

                  if (i === changes.length - 1) {
                    setFormState((formState) => ({
                      ...formState,
                      invoice_Accounts_list: tempArr,
                    }));
                  }
                }
              })
              .catch(function (err) {
                tempArr[changes[i][0]]["costCenterOwner"] = "";
                tempArr[changes[i][0]]["costCenterOwnerName"] = "";
                if (i === changes.length - 1) {
                  setFormState((formState) => ({
                    ...formState,
                    invoice_Accounts_list: tempArr,
                  }));
                }
                console.log(err);
              });
            await axios({
              method: "get", //you can set what request you want to be
              url: `${
                process.env.REACT_APP_API_URL
              }/api/Invoices/GetCostCenters_v1/${_cc.split("-")[0].trim()}`,
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                "Content-Type": "application/json",
              },
            })
              .then((response) => {
                if (response.data != undefined) {
                  tempArr[changes[i][0]]["costCenter"] =
                    response.data[0].CostCenterCode +
                    " - " +
                    response.data[0].Name;

                  if (i === changes.length - 1) {
                    setFormState((formState) => ({
                      ...formState,
                      invoice_Accounts_list: tempArr,
                    }));
                  }
                }
              })
              .catch(function (err) {
                tempArr[changes[i][0]]["costCenter"] = "";
                if (i === changes.length - 1) {
                  setFormState((formState) => ({
                    ...formState,
                    invoice_Accounts_list: tempArr,
                  }));
                }
                console.log(err);
              });
          } else {
            tempArr[changes[i][0]]["costCenterOwner"] = "";
            tempArr[changes[i][0]]["costCenterOwnerName"] = "";
            tempArr[changes[i][0]]["costCenter"] = "";
          }
        }
        tempArr[changes[i][0]]["description"] = formState?.invoice_Desc;
      } else if (changes[i][1] == "glAccount") {
        var _ca = changes[i][3];
        const isFS = formState?.invoiceCategory?.includes("Final Settlement");
        if (isFS && tempArr[0].glAccount !== _ca) {
          //  error
          setAlertMessage("Please don't select different GL Account");
          tempArr[changes[i][0]]["glAccount"] = "";
        } else if (_ca != null && _ca != "" && _ca.split("-").length > 0) {
          // old value
          if (changes[i][2] === undefined) {
            tempArr[changes[i][0]]["amount"] = adjustAmountOnGLTable(tempArr);
          }

          tempArr[changes[i][0]]["glAccount"] = changes[i][3];
          // if (changes.length > 1) {
          let _gl = "-1";
          if (_ca != null && _ca != "" && _ca.split("-").length > 0) {
            _gl = _ca.split("-")[0].trim();
          }
          await axios({
            method: "get", //you can set what request you want to be
            url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetChargeAccount_v1/${_gl}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.data.length > 0)
                tempArr[changes[i][0]]["glAccount"] =
                  response.data[0].GLAccount +
                  " - " +
                  response.data[0].ShortText;
              else tempArr[changes[i][0]]["glAccount"] = "";

              if (i === changes.length - 1) {
                setFormState((formState) => ({
                  ...formState,
                  invoice_Accounts_list: tempArr,
                }));
              }
              // if (changes.length === 1) {
              //   var amt = formState?.invoice_Amount - formState?.salesTaxAmount;
              //   var amt1 = 0;
              //   tempArr.forEach(function (v, k) {
              //     if (v[1] != undefined && k != changes[i][0]) amt1 += v[1];
              //   });
              //   tempArr[changes[i][0]]["amount"] = amt - amt1;
              // }
            })
            .catch(function (err) {
              tempArr[changes[i][0]]["glAccount"] = "";

              if (i === changes.length - 1) {
                setFormState((formState) => ({
                  ...formState,
                  invoice_Accounts_list: tempArr,
                }));
              }
              console.log(err);
            });
          // }

          //return;
        }
        // var instance = self.getInstance();
        if (
          formState?.salesTaxCode?.split(" - ")[0] != null &&
          formState?.salesTaxCode?.split(" - ")[0] != ""
        ) {
          tempArr[changes[i][0]]["stCode"] = formState?.salesTaxCode
            .split("-")[0]
            .trim();
        }

        tempArr[changes[i][0]]["description"] = formState?.invoice_Desc;
      } else if (changes[i][1] == "amount") {
        if (changes[i][1]) {
          const amt = changes[i][3];
          if (typeof amt === "string") {
            const amt1 = Number(amt.replace(/,/g, ""));
            tempArr[changes[i][0]]["amount"] = amt1?.toFixed(2);
          } else {
            tempArr[changes[i][0]]["amount"] = amt?.toFixed(2);
          }
        } else tempArr[changes[i][0]]["amount"] = 0;
      } else if (changes[i][1] == "profitCenter") {
        if (!tempArr[changes[i][0]]["costCenter"]) {
          tempArr[changes[i][0]]["profitCenter"] = changes[i][3];
        } else {
          setAlertMessage(
            "Cost center is already selected, so can't enter profit center"
          );
          tempArr[changes[i][0]]["profitCenter"] = "";
        }
      } else if (changes[i][1] == "wbsElement") {
        if (!tempArr[changes[i][0]]["costCenter"]) {
          tempArr[changes[i][0]]["wbsElement"] = changes[i][3];
        } else {
          setAlertMessage(
            "Cost center is already selected, so can't enter WBS Element"
          );
          tempArr[changes[i][0]]["wbsElement"] = "";
        }
      } else if (changes[i][1] == "description") {
        tempArr[changes[i][0]]["description"] = changes[i][3];
      } else if (changes[0][1] == "horizonId") {
        var _cc = changes[i][3];

        // get horizon id
        if (_cc) {
          await axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetEmployeeList_v1/${_cc.split("-")[0].trim()}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.data != undefined) {
                tempArr[changes[i][0]]["department"] =
                  response.data[0].department;
                tempArr[changes[i][0]]["horizonId"] =
                  response.data[0].employeeCode +
                  " - " +
                  response.data[0].employeeName;

                if (i === changes.length - 1) {
                  setFormState((formState) => ({
                    ...formState,
                    invoice_Accounts_list: tempArr,
                  }));
                }
              }
            })
            .catch(function (err) {
              console.log(err);
            });

          // get vendor code
          await axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetEmployeeVendorCode/${_cc.split("-")[0].trim()}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.data != undefined) {
                tempArr[changes[i][0]]["vendor_Code"] =
                  response.data[0].vendor_Code +
                  " - " +
                  response.data[0].vendor_Name;

                if (i === changes.length - 1) {
                  setFormState((formState) => ({
                    ...formState,
                    invoice_Accounts_list: tempArr,
                  }));
                }
              }
            })
            .catch(function (err) {
              console.log(err);
            });
        }

        tempArr[changes[i][0]]["description"] = formState?.invoice_Desc;
      } else if (changes[0][1] == "vendor_Code") {
        var _cc = changes[i][3];
        if (_cc != null && _cc != "" && _cc.split("-").length > 0) {
          tempArr[changes[i][0]]["wbsElement"] = "";

          let _gl = "-1";
          if (_cc != null && _cc != "" && _cc.split("-").length > 0) {
            _gl = _cc.split("-")[0].trim();
          }

          await axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/InvoiceDetails/getVendorDetails/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.data.length > 0)
                tempArr[changes[i][0]]["vendor_Code"] =
                  response.data[0].Vendor_Code +
                  " - " +
                  response.data[0].Vendor_Name;
              else tempArr[changes[i][0]]["vendor_Code"] = "";

              if (i === changes.length - 1) {
                setFormState((formState) => ({
                  ...formState,
                  invoice_Accounts_list: tempArr,
                }));
              }
            })
            .catch(function (err) {
              tempArr[changes[i][0]]["vendor_Code"] = "";
              if (i === changes.length - 1) {
                setFormState((formState) => ({
                  ...formState,
                  invoice_Accounts_list: tempArr,
                }));
              }
              console.log(err);
            });

          await axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetEmployeeHorizenID/${_cc.split("-")[0].trim()}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (response.data != undefined) {
                tempArr[changes[i][0]]["department"] =
                  response.data[0].department;
                tempArr[changes[i][0]]["horizonId"] =
                  response.data[0].employeeCode +
                  " - " +
                  response.data[0].employeeName;

                if (i === changes.length - 1) {
                  setFormState((formState) => ({
                    ...formState,
                    invoice_Accounts_list: tempArr,
                  }));
                }
              }
            })
            .catch(function (err) {
              console.log(err);
            });
          tempArr[changes[i][0]]["description"] = formState?.invoice_Desc;
        }
      } else if (changes[i][1] == "fsDocNo") {
        tempArr[changes[i][0]]["fsDocNo"] = changes[i][3];
      } else if (changes[i][1] == "fsDocDate") {
        tempArr[changes[i][0]]["fsDocDate"] = changes[i][3];
      }
    }
let updatedArr = [...tempArr];

// Only for Customer Finance
if (formState.invoice_Type === "Final Settlement - Distributor") {
  updatedArr = updatedArr.map((row) => ({
    ...row,
    glAccount: row.glAccount || row.vendor_Code || "", // if glAccount is missing, use vendor_Code
  }));
   setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: updatedArr,
    }));
  }
  else {
     setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: tempArr,
    }));
  };
}  
  const handleBeforeChange = (changes, source) => {
    if (source == "CopyPaste.paste" && changes[0][1] == 1)
      changes[0][3] = changes[0][3] = changes[0][3].replaceAll(",", "").trim();
  };

  const handleBeforeRemoveRow = (a, b, c, d, e, f) => {
    let tempArr = formState.invoice_Accounts_list;
    for (let index = 0; index < c.length; index++) {
      const rowIndex = c[index];
      const rowId = formState.invoice_Accounts_list[rowIndex].rowId;
      tempArr = tempArr.filter((x) => x.rowId !== rowId);
    }
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: tempArr,
    }));
  };

  useEffect(() => {
    const data = [
      {
        data: "rowId", // auto-number column (no data field)
        readOnly: true,
        width: 40,
        renderer: function (instance, td, row, col, prop, value, cellProperties) {
          td.innerHTML = row + 1; // Auto-increment row number
          td.style.textAlign = "center";
          return td;
        },
      },
      {
        data: "glAccount",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let _gl = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _gl = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetChargeAccount_v1/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.GLAccount + " - " + m.ShortText;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "amount",
        width: 200,
        type: "numeric",
        numericFormat: {
          pattern: "0,0.00",
          culture: "en-US", // this is the default culture, set up for USD
        },
      },
      {
        data: "costCenter",
        type: "autocomplete",
        readOnly: formState?.invoice_Type === "Rent",
        source: function (query, proces) {
          var data = { query: query };
          let _ca = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _ca = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetCostCenters_v1/${_ca ? _ca : "-1"}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.CostCenterCode + " - " + m.Name;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        renderer:
  formState?.invoice_Type === "Rent"
    ? function (instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
        td.style.backgroundColor = "#F0F0F0"; // gray background
        return td;
      }
    : Handsontable.renderers.AutocompleteRenderer, // default renderer if not Rent

        strict: false,
        width: 180,
      },
      {
        data: "costCenterOwner",
        width: 70,
        type: "text",
        readOnly: true,   
      },
      {
        data: "costCenterOwnerName",
        width: 240,
        type: "text",
        readOnly: true,
         renderer:
  formState?.invoice_Type === "Rent"
    ? function (instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
        td.style.backgroundColor = "#F0F0F0"; // gray background
        return td;
      }
    : Handsontable.renderers.AutocompleteRenderer,
      },

      {
        data: "profitCenter",
        width: 110,
        type: "text",
      },
      {
        data: "wbsElement",
        width: 130,
        type: "text",
      },
      {
        data: "description",
        width: 190,
        type: "text",
      },
    ];

    const finalSettelmentAdditionalCol = [
      {
        // data: "FS Doc",
        data: "fsDocNo",
        width: 200,
        type: "text",
      },
      {
        // data: "FS Doc Date",
        data: "fsDocDate",
        width: 200,
        type: "date",
        dateFormat: "YYYY-MM-DD",
      },
    ];
    const hrData = [
      {
        data: "rowId", // auto-number column (no data field)
        readOnly: true,
        width: 40,
        renderer: function (instance, td, row, col, prop, value, cellProperties) {
          td.innerHTML = row + 1; // Auto-increment row number
          td.style.textAlign = "center";
          return td;
        },
      },
      {
        data: "glAccount",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let _gl = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _gl = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetChargeAccount_v1/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.GLAccount + " - " + m.ShortText;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "amount",
        width: 200,
        type: "numeric",
        numericFormat: {
          pattern: "0,0.00",
          culture: "en-US", // this is the default culture, set up for USD
        },
      },
      {
        data: "horizonId",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let hi = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            hi = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetEmployeeList_v1/${hi ? hi : null}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.employeeCode + " - " + m.employeeName;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "vendor_Code",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let _gl = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _gl = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/InvoiceDetails/getVendorDetails/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.Vendor_Code + " - " + m.Vendor_Name;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "department",
        width: 200,
        type: "text",
      },
      {
        data: "costCenter",
        type: "autocomplete",
        source: function (query, proces) {
          var data = { query: query };
          let _ca = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _ca = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetCostCenters_v1/${_ca ? _ca : "-1"}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.CostCenterCode + " - " + m.Name;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 180,
      },
      {
        data: "costCenterOwner",
        width: 70,
        type: "text",
        readOnly: true,
      },
      {
        data: "costCenterOwnerName",
        width: 240,
        type: "text",
        readOnly: true,
      },

      {
        data: "profitCenter",
        width: 110,
        type: "text",
      },
    ];
    const checkboxColumn = {
    data: "selected", // Use a property name that won't affect your data
    type: "checkbox",
    width: 60,
    readOnly: true,
    className: "htCenter htMiddle",
    renderer: function (instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.CheckboxRenderer.apply(this, arguments);
      const checkbox = td.querySelector("input");
      if (checkbox) {
        checkbox.checked = true;   // always checked
        checkbox.disabled = true;  // always disabled
      }
      return td;
    },
  };
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;

  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const isReviewerOrApprover =
  role.roleName === "Reviewer" || role.roleName === "Loam Approver";
  const roleStr = typeof role === "object" ? role?.roleName : role;
  const usesPropData = roleStr === "IP" || roleStr === "Reviewer" || roleStr === "Loam Approver";
  console.log(usesPropData,'usesPropData')
  const distributorCols = [
  checkboxColumn,
  {
    data: function (row, value) {
      if (typeof value === 'undefined') {
        return row?.customerAccountNo || row?.CustomerAccountNo || "";
      }
    },
    title: "Customer Account No",
    width: 200,
    type: "text",
    readOnly: true,
  },
  {
    data: function (row, value) {
      if (typeof value === 'undefined') {
        return row?.fsDocNo || row?.FSDocNo || "";
      }
    },
    title: "FSDS Doc",
    width: 200,
    type: "text",
    readOnly: true,
  },
  {
    data: function (row, value) {
      if (typeof value === 'undefined') {
        return row?.fsDocDate || row?.FSDocDate || "";
      }
    },
    title: "FSDS Date",
    width: 200,
    type: "date",
    dateFormat: "YYYY-MM-DD",
    readOnly: true,
    renderer: (instance, td, row, col, prop, value) => {
      const rowData = instance.getSourceDataAtRow(row);
      const dateVal = value || rowData?.fsDocDate || rowData?.FSDocDate || "";
      const formattedDate = formatDate(dateVal);
      td.textContent = formattedDate;
      return td;
    },
  },
  {
    data: function (row, value) {
      if (typeof value === 'undefined') {
        return row?.amount ?? row?.Amount ?? 0;
      }
    },
    title: "Amount",
    width: 200,
    type: "numeric",
    numericFormat: {
      pattern: "0,0.00",
      culture: "en-US",
    },
    readOnly: true,
  },
  {
    data: function (row, value) {
      if (typeof value === 'undefined') {
        return row?.vendor_Code || row?.VendorCode || row?.vendorCode || "";
      }
    },
    title: "Vendor Code",
    width: 300,
    type: "text",
    readOnly: true,
  },
];


    const cols =
      role === "HR"
        ? formState.invoiceCategory.includes("Final Settlement")
          ? [...finalSettelmentAdditionalCol, ...hrData]
          : hrData
        : ( formState.invoice_Type === "Final Settlement - Distributor") ?
          distributorCols
        : data;
    setColumns(cols);
  }, [formState.invoice_Accounts_list, formState.invoiceCategory , formState?.invoice_Type]);
  
  useEffect(() => {

    if (role === "IR" && formState.invoice_Type === "Final Settlement - Distributor") {
      console.log(formState?.invoice_Accounts_list , "listing formState?.invoice_Accounts_list useEffect")
    }

  }, [formState.invoice_Accounts_list , formState.invoice_Type])


  useEffect(() =>{
    if ( role === "IR" && formState.invoice_Type === "Final Settlement - Distributor" && formState?.invoice_Id==0) {
      if(formState?.distributor_Code!==""){
        getDistributorData(setFormState, formState)
      } 
    }

  },[role , formState?.distributor_Code   ])


  useEffect(() => {
  if ( formState.invoice_Type === "Final Settlement - Distributor") {
    // Map invoice_Accounts_list and inject vendor_Code
    const updatedList = formState?.invoice_Accounts_list?.map(row => ({
      ...row,
      vendor_Code: formState?.vendor_Code?.Vendor_Code
        ? `${formState.vendor_Code.Vendor_Code} - ${formState.vendor_Code.Vendor_Name}`
        : "" // if undefined, set to ""
    }));

    setFormState(prev => ({
      ...prev,
      invoice_Accounts_list: updatedList,
    }));
  }
}, [formState.vendor_Code, role, formState.invoice_Type]);

  const calculateTotalGLAmount = () => {
    const totalGLAmount = formState?.invoice_Accounts_list?.reduce(
      (accumulator, currentValue) => {
        const rawAmount = currentValue?.amount ?? currentValue?.Amount ?? 0;
        const amountWithoutCommas = String(rawAmount).replace(
          /,/g,
          ""
        );
        const numericAmount = Number(Number(amountWithoutCommas)?.toFixed(2));

        return accumulator + numericAmount;
      },
      0
    );
    return totalGLAmount;
  };
  const totalAmount = calculateTotalGLAmount();
 
  useEffect(()=>{
if(formState?.invoice_Type === "Final Settlement - Distributor" && role === "IR"){
  const normalizedTotalAmount = totalAmount < 0 ? totalAmount * -1 : totalAmount;
  const Amount=normalizedTotalAmount?.toLocaleString();
  if(typeof setInvoice_Amount_formatted === 'function') {
    setInvoice_Amount_formatted(Amount);
  }
  if(formState?.invoice_Id===0){
  if(totalAmount > 0){
    setErrorMessage("Total Customer Account Amount should not be positive. Please check the amounts entered.");
  }else{
    setErrorMessage("");
  }}
}
  },[totalAmount , formState?.invoice_Type])

  useEffect(() => {
    const handleResize = () => {
      if (hotRef.current) {
        hotRef.current.hotInstance.render(); // ✅ re-render the table
        hotRef.current.hotInstance.updateSettings({ stretchH: "all" }); // ✅ re-stretch
      }
    };

    // Listen for window resize (sidebar collapse triggers resize)
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setFormState({
      ...formState,
      glAccount: formState?.invoice_Accounts_list?.vendor_Code
    })
  }, [formState?.invoice_Accounts_list])

  const Role = typeof role === "object" ? role?.roleName : role;
  const tblData = ((Role === "IP" || Role === "Reviewer" || Role === "Loam Approver") && formState.invoice_Type === "Final Settlement - Distributor")
    ? data
    : formState?.invoice_Accounts_list; 
      useEffect(() => {
  const rowCount = tblData?.length || 1;

  // First row = 80, then +40 per extra row
  const calculatedHeight = Math.min(
    ROW_HEIGHT + (rowCount - 1) * ROW_INCREMENT,
    MAX_HEIGHT
  );
  setTableHeight(calculatedHeight);
}, [tblData?.length]);
    
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ width: "0", zIndex: "0" }}
      >
        {/* <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
             <LinearProgress color="info" />
             <LinearProgress color="info" />
             <LinearProgress color="info" />
  </Stack> */}
        <HotTable
          className="custom-hot-table"
          data={tblData}
          colHeaders={
            role === "HR" 
              ? formState.invoiceCategory.includes("Final Settlement")
                ? [...fsCols, ...hrColumnHeaders]
                : hrColumnHeaders
              :  formState.invoice_Type === "Final Settlement - Distributor"
                ? distributorCols
                :columnHeaders
          }
          columns={columns}
          manualRowResize={true}
          manualColumnResize={true}
          rowHeaders={false}
          height={tableHeight}  // <-- dynamic height
  afterBeginEditing={(row, col) => {
    const colData = columns[col]?.data;
    if (colData === "glAccount" || colData === "costCenter") {
      setTableHeight(MAX_HEIGHT);
    }
  }}
afterDeselect={() => {
  const rowCount = tblData?.length || 1;
  const calculatedHeight = Math.min(
    ROW_HEIGHT + (rowCount - 1) * ROW_INCREMENT,
    MAX_HEIGHT
  );
  setTableHeight(calculatedHeight);
}}
          // height="auto"
          rowHeaderWidth={25}
          contextMenu={true}
          filters={true}
          width="100%"
       hiddenColumns={{
          indicators: true,
          columns:
            role === "HR"
              ? formState.invoiceCategory.includes("Final Settlement")
                ? [9] // was [8] before adding auto-number column
                : [7] // was [6]
              : formState.invoice_Type === "Final Settlement - Distributor"
                ? formState.invoice_Type === "Final Settlement - Distributor"
                  ? [3,5,7,8,9,10] // incremented indices
                  : [1,3,5,6] 
                : [4], // default was [3]
        }}

          readOnly={reviwerFlag}
          dropdownMenu={true}
          ref={hotRef}
          beforeChange={handleBeforeChange}
          beforeRemoveRow={handleBeforeRemoveRow}
          afterChange={handleAfterChange}
          licenseKey="non-commercial-and-evaluation" // for non-commercial use
        />
        {(role === "HR" || ( formState.invoice_Type === "Final Settlement - Distributor")) && (
          <Grid container spacing={0} mt={1}>
            <Grid item sm={6} md={3} lg={1}>
              <b>{`${formState.invoice_Type==='Final Settlement - Distributor' ? 'Customer Account Total' : 'Total GL Amount'}:`}</b>
            </Grid>
            <Grid item sm={6} md={3} lg={2} style={{ paddingLeft: "4px" }}>
              <b>
                {totalAmount?.toLocaleString() || 0.0}
                {/* {addZeroes(
                  formState?.invoice_Accounts
                    ?.map((data) => data.amount)
                    .reduce((prev, curr) => Number(prev) + Number(curr), 0)
                )} */}
              </b>
            </Grid>
          </Grid>
        )}
        {!reviwerFlag && formState?.invoice_Type !== "Final Settlement - Distributor" && (
          <Box display="flex" justifyContent={"flex-end"} mt={2}>
            <Button color="secondary" variant="contained" onClick={addInput}>
              Add New Row
            </Button>
          </Box>
        )}
        {alertMessage && (
          <CustomSnackbar
            open={alertMessage !== ""}
            message={alertMessage}
            handleClose={() => setAlertMessage("")}
            variant="error"
          />
        )}
        {vendorblock && (
          <POAlertDialog
            setAlertMessage={setvendorblock}
            message={erralertMessage}
            setErrAlertMessage={() => {}}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default React.memo(GL_TableV2);
